// material-ui
import { alpha, createTheme } from '@mui/material/styles';

// project imports
import { ThemeMode } from 'config';

// assets
import defaultColor from 'assets/scss/_themes-vars.module.scss';
import theme1 from 'assets/scss/_theme1.module.scss';
import theme2 from 'assets/scss/_theme2.module.scss';
import theme3 from 'assets/scss/_theme3.module.scss';
import theme4 from 'assets/scss/_theme4.module.scss';
import theme5 from 'assets/scss/_theme5.module.scss';
import theme6 from 'assets/scss/_theme6.module.scss';

// ==============================|| DEFAULT THEME - PALETTE ||============================== //

export default function Palette(mode, presetColor) {
  let colors;
  switch (presetColor) {
    case 'theme1':
      colors = theme1;
      break;
    case 'theme2':
      colors = theme2;
      break;
    case 'theme3':
      colors = theme3;
      break;
    case 'theme4':
      colors = theme4;
      break;
    case 'theme5':
      colors = theme5;
      break;
    case 'theme6':
      colors = theme6;
      break;
    case 'default':
    default:
      colors = defaultColor;
  }

  return createTheme({
    palette: {
      mode,
      common: {
        black: colors.darkPaper
      },
      primary: {
        light: mode === ThemeMode.DARK ? colors.darkPrimaryLight : colors.primaryLight,
        main: mode === ThemeMode.DARK ? colors.darkPrimaryMain : colors.primaryMain,
        dark: mode === ThemeMode.DARK ? colors.darkPrimaryDark : colors.primaryDark,
        200: mode === ThemeMode.DARK ? colors.darkPrimary200 : colors.primary200,
        800: mode === ThemeMode.DARK ? colors.darkPrimary800 : colors.primary800
      },
      secondary: {
        light: mode === ThemeMode.DARK ? colors.darkSecondaryLight : colors.secondaryLight,
        main: mode === ThemeMode.DARK ? colors.darkSecondaryMain : colors.secondaryMain,
        dark: mode === ThemeMode.DARK ? colors.darkSecondaryDark : colors.secondaryDark,
        200: mode === ThemeMode.DARK ? colors.darkSecondary200 : colors.secondary200,
        800: mode === ThemeMode.DARK ? colors.darkSecondary800 : colors.secondary800
      },
      error: {
        light: colors.errorLight,
        200: colors.error200,
        400: colors.error400,
        main: colors.errorMain,
        900: colors.error900,
        dark: colors.errorDark,
        50: colors.error50
      },
      orange: {
        light: colors.orangeLight,
        main: colors.orangeMain,
        dark: colors.orangeDark
      },
      critical: {
        main: colors.criticalMain
      },
      warning: {
        light: colors.warningLight,
        main: colors.warningMain,
        dark: colors.warningDark,
        contrastText: mode === ThemeMode.DARK ? colors.darkTextPrimary : colors.grey700
      },
      success: {
        light: colors.successLight,
        200: colors.success200,
        main: colors.successMain,
        dark: colors.successDark,
        900: colors.success900
      },
      cyan: {
        50: colors.cyan50,
        800: colors.cyan800,
        900: colors.cyan900,
        dark: colors.cyanDark
      },
      teal: {
        50: colors.teal50,
        100: colors.teal100,
        500: colors.teal500,
        600: colors.teal600,
        700: colors.teal700,
        800: colors.teal800,
        900: colors.teal900
      },
      purple: {
          100: colors.purple100,
          200: colors.purple200,
          300: colors.purple300,
      },
      bluegrey: {
        dark: mode === ThemeMode.DARK ? colors.grey600: colors.bluegrey100,
        light: mode === ThemeMode.DARK ? colors.darkLevel1 : colors.bluegreyDark200,
        700: colors.bluegrey700,
        800: colors.bluegrey800
      },
      grey: {
        50: colors.grey50,
        100: colors.grey100,
        150: mode === ThemeMode.DARK ? colors.darkHeader : colors.grey150,
        250: colors.grey250,
        350: colors.grey350,
        500: mode === ThemeMode.DARK ? colors.darkTextSecondary : colors.grey500,
        600: mode === ThemeMode.DARK ? colors.darkTextSecondary : colors.grey600,
        700: mode === ThemeMode.DARK ? colors.darkTextPrimary : colors.grey700,
        800: mode === ThemeMode.DARK ? colors.darkTextPrimary : colors.grey800,
        900: mode === ThemeMode.DARK ? colors.darkTextPrimary : colors.grey900,
      },
      white: {
        paper: colors.paper,
      },
      dark: {
        light: colors.darkTextPrimary,
        main: colors.darkLevel1,
        dark: colors.darkLevel2,
        gradient: colors.darkGradient,
        800: colors.darkBackground,
        900: colors.darkPaper
      },
      text: {
        primary: mode === ThemeMode.DARK ? colors.darkTextPrimary : colors.grey700,
        secondary: mode === ThemeMode.DARK ? colors.darkTextSecondary : colors.grey600,
        dark: mode === ThemeMode.DARK ? colors.darkTextPrimary : colors.grey900,
        hint: colors.grey100
      },
      divider: mode === ThemeMode.DARK ? '#29282D' : colors.grey200,
      background: {
        paper: mode === ThemeMode.DARK ? colors.darkLevel2 : colors.paper,
        default: mode === ThemeMode.DARK ? colors.darkPaper : colors.paper
      },
      lightBlue: {
        900: colors.lightBlue900,
        100: mode === ThemeMode.DARK ? colors.paper : colors.lightBlue100
      },
      blue: {
        50: mode === ThemeMode.DARK ? colors.darkBlue50 : colors.blue50
      },
      dialogError: {
        light: mode === ThemeMode.DARK ? colors.dialogErrorDark : colors.dialogErrorLight
      },
      stack: {
        rail: colors.teal500 || '#009688',
        // Text-grade amber for bare text on white; warning.main is ~1.95:1, under the 4.5:1 AA floor.
        statusTextWarning: '#8A5300',
        managerBg: colors.warningLight || '#fff8e1',
        managerColor: '#e65100',
        backupBg: '#e3f2fd',
        backupColor: '#1565c0',
        memberBg: colors.purple100 || '#ede7f6',
        memberColor: '#5e35b1',
        // Stack-Topology role/ports pills (exact values sampled from Figma).
        topologyPill: {
          teal: { bg: '#E5F1F1', border: '#8CC1BC', text: '#4F9289' }, // Management / Standby
          grey: { bg: '#EDEFF1', border: '#BDC1C6', text: '#2E3748' }, // Member
          amber: { bg: '#FDF8E3', border: '#F2D6AE', text: '#D97F2C' } // Not Joined
        }
      }
    }
  });
}
